import styled from 'styled-components';
import Tabs from 'react-bootstrap/Tabs';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Dropdown from 'react-bootstrap/Dropdown';
import Accordion from 'react-bootstrap/Accordion';

export const WalletContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 20px;
  gap: 32px;
  width: 65%;
  height: 403px;
  background: #272a2f;
  border-radius: 20px;
  &.w-full {
    width: 100%;
    height: 350px;
  }
  & .tab-content {
    width: calc(100% - 36px) !important;
    @media screen and (max-width: 767px) {
      width: 100% !important;
    }
  }
`;
export const RowWrapper = styled.tr`
  display: inline-table;
  width: 100%;
  border-style: none !important;
  margin-top: 15px;
`;
export const Title = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 120%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #ffffff;
`;

export const BalanceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  width: 325px;
  @media screen and (max-width: 767px) {
    width: 100% !important;
  }
`;

export const AccordionWrapper = styled(Accordion)`
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  background: transparent !important;
  width: 100%;
`;

export const AccordionHeader = styled(Accordion.Header)`
  background: transparent !important;
  border: none;
  & .accordion-button {
    background: transparent !important;
    color: #ffdc5e !important;
  }
  & .accordion-button::after {
    background-image: url(https://static.zone.game/images/homapage/ChevronDownGradiant.svg);
  }
  & .accordion-button:focus {
    box-shadow: none;
  }
`;
export const AccordionBodyWrapper = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  width: 100%;
  padding-top: 35px;
`;

export const TabsContainer = styled(Tabs)`
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  & .nav-link.active {
    background: #343740;
    border-radius: 11px;
  }
  & .nav-link {
    color: #fff;
  }
`;
export const CustomisedTab = styled.div`
  width: 80px;
  height: 48px;
  background: #343740;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
export const CustomisedTabTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 150%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #ffffff;
`;
export const WalletAddressBox = styled.div`
  width: 386px;
  height: 48px;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  margin-top: 24px;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  text-align: center;
  line-height: 22px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: #ffdc5e;
  padding: 13px;
  &.w-250 {
    width: 250px !important;
  }
`;
export const CopyAddressBtn = styled.button`
  width: 154px;
  height: 40px;
  background: linear-gradient(92.97deg, #ffdc5e 0.13%, #fcc601 99.87%);
  border-radius: 10px;
  font-weight: 600;
  font-size: 14px;
  line-height: 130%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  color: #000000;
  margin-top: 20px;
`;
export const FormLabel = styled(Form.Label)`
  font-weight: 400;
  font-size: 14px;
  line-height: 130%;
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.7);
`;

export const FormControl = styled(Form.Control)`
  height: 48px;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #ffffff;
  &.w-full {
    width: 270px !important;
  }
`;
export const CurrencyContainer = styled(Dropdown)`
  height: 48px;
  background: #36393e;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0px 8px 8px 0px;
  width: 20%;
  position: absolute;
  right: 0px;
  color: #fff;
  &.w-34 {
    width: 34% !important;
  }
`;
export const CurrencyToggle = styled(Dropdown.Toggle)`
  background: #36393e;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0px 8px 8px 0px;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
`;
export const TableHeading = styled.td`
  font-weight: 600;
  font-size: 12px;
  line-height: 150%;
  align-items: center;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.5);
  flex: none;
  flex-grow: 0;
  z-index: 2;
`;
export const TableCol = styled.td`
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  max-width: 100px;
  border-style: none !important;
  color: #ffffff !important;
  &.overflowContent {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`;
export const TableBody = styled.tbody`
  display: block;
  overflow: auto;
  height: 180px;
`;
export const TotalAssets = styled.div`
  font-weight: 600;
  font-size: 36px;
  line-height: 120%;
  width: 100%;
  &.borderBottom {
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  }
  background: linear-gradient(92.97deg, #ffdc5e 0.13%, #fcc601 99.87%),
    linear-gradient(92.97deg, #ffdc5e 0.13%, #fcc601 99.87%), #ffffff;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  &.font400 {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }
`;
export const ModalHeader = styled(Modal.Header)`
  background: linear-gradient(180deg, #ff0000 0%, #030000 100%);
  border-radius: 30px !important;
  color: #fff;
  height: 131px;
  align-items: baseline !important;
`;
export const ModalWrapper = styled(Modal)`
  & .modal-content {
    position: relative;
    border-radius: 30px !important;
    background: linear-gradient(180deg, #181b21 0%, #333740 100%);
  }
`;
export const ModalBodyWrapper = styled.div`
  background: linear-gradient(180deg, #181b21 0%, #333740 100%);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 30px;
  color: #fff;
  position: absolute;
  top: 56px;
  left: 0;
  height: 268px;
`;
export const ModalHeading1 = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 160%;
  text-align: center;
  letter-spacing: -0.01em;
  color: #ffffff;
`;
export const ModalHeading2 = styled.div`
  font-weight: 400;
  font-size: 19px;
  line-height: 21px;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
`;
export const AddressWrapper = styled.span`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100px;
  margin-bottom: -4px;
  display: inline-block;
`;
export const Info = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  &.assetBalance {
    color: rgba(255, 255, 255, 0.5);
    line-height: 24px;
  }
`;
export const ErrorMessage = styled.div`
  color: #dc3545 !important;
  margin-top: 3px;
  font-size: 13px;
`;
